import { render, staticRenderFns } from "./DefectiveGoodsTransfer.vue?vue&type=template&id=a9d00d26&scoped=true"
import script from "./DefectiveGoodsTransfer.vue?vue&type=script&lang=js"
export * from "./DefectiveGoodsTransfer.vue?vue&type=script&lang=js"
import style0 from "./DefectiveGoodsTransfer.vue?vue&type=style&index=0&id=a9d00d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d00d26",
  null
  
)

export default component.exports